<template>
    <div id="main-navbar">
        <div class="sidebar-header">
            <div class="nav-title company-logo nav-group-title pt-2 pb-3">
                <a href="/"><img src="../../assets/images/logo.jpg"/></a>
            </div>
        </div>
        <button type="button" id="sidebarCollapse" class="menu-btn btn btn-light d-lg-none">
            <i class="fas fa-bars"></i>
        </button>
        <div class="wrapper">
            <nav id="sidebar">
                <ul class="list-unstyled components">
                    <div v-for="group in module_groups">
                    <h6 class="nav-group-title">{{group.name}}</h6>
                    <li class="active top-menu-item" v-for="module in getApplicationModuleByGroupID(group.id)"  v-if="requiresAdmin(module.requires_admin)">
                        <router-link :to="module.path" v-on:click.native="routerClicked">
                            <div class="item-icon-wrapper">
                                <i :class="module.icon"></i>
                            </div>
                            <span>{{module.name}}</span>
                            <span class="notification-circle" v-if="getNotification(module.notification_property)">
                                {{ getNotification(module.notification_property) }}
                            </span>
                        </router-link>
                    </li>
                    </div>
                    <div class="myacc-group d-lg-none">
                        <h6 class="nav-group-title">Fiók</h6>

                        <li class="active top-menu-item">
                            <router-link to="/my-account" v-on:click.native="routerClicked">
                                <div class="item-icon-wrapper">
                                    <i class="fas fa-user-circle"></i>
                                </div>
                                <span>Fiók adatok</span>
                            </router-link>
                        </li>

                        <li class="active top-menu-item">
                            <router-link to="/my-account/change-password" v-on:click.native="routerClicked">
                                <div class="item-icon-wrapper">
                                    <i class="fas fa-key"></i>
                                </div>
                                <span>Jelszóváltoztatás</span>
                            </router-link>
                        </li>

                        <li class="active top-menu-item">
                            <a @click="logout">
                                <div class="item-icon-wrapper">
                                    <i class="fas fa-sign-out-alt text-danger"></i>
                                </div>
                                <span>Kijelentkezés</span>
                            </a>
                        </li>

                    </div>
                </ul>
            </nav>
        </div>

    </div>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default{
        name: 'Navbar',
        data(){
            return {
                notification_delay: 60000, //1m
            }
        },
        computed: {
            ...mapGetters([
                'appSettings',
                'applicationModules',
                'applicationModuleGroups',
                'user',
                'notifications',
            ]),
            isUserLoggedIn(){
                return this.user && this.user.ID > 0;
            },
            notification_data: {
                get: function() {
                    return this.notifications;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            module_groups: {
                get: function() {
                    return this.applicationModuleGroups ? this.applicationModuleGroups : [];
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            modules: {
                get: function() {
                    return this.applicationModules ? this.applicationModules : [];
                },
                set: function(newVal) {
                    return newVal;
                }
            },

        },
        methods:{
            ...mapActions([
                'getApplicationModules',
                'getNotifications',
            ]),
            requiresAdmin(req_adm) {
                if(req_adm == 1) {
                    if(this.user && this.user.is_admin == 1) {
                        return true;
                    } else {
                        return false;
                    }
                }

                return true;
            },
          toggleNavigation(){
              $('#sidebarCollapse').on('click', function () {

                  if($('#sidebar').hasClass('active')){ //hide menu, show content
                      //$('.main-content').css('margin-top', '-69px');
                      $('.main-content').show();

                      $('#main-navbar .wrapper').hide();
                      $('.main-sidebar').css('height', '55px');
                  }else{
                      $('.main-content').hide();

                      $('#main-navbar .wrapper').show();
                      $('.main-sidebar').css('height', '100vh');
                  }

                  $('#sidebar').toggleClass('active', 5000);
              });
            },

            logout: function(){
                this.$store.dispatch('logout').then((response) => {
                    if(response.data){
                        this.$messaging.DisplaySuccess('', 'Ön kilépett a rendszerből.');
                        this.$emit('onLoggedOut');
                        this.$store.commit('setOnLogoutProgress', false);
                    }else{
                        this.$messaging.DisplayError('Logout error', 'Hiba történt!');
                    }
                }).catch((err) => {
                    this.$messaging.DisplayError('Logout error', 'Sikertelen kijelentkezés!');
                });
            },
            routerClicked() {
                if ( $('#sidebarCollapse').is(":visible")) {
                    $('#sidebarCollapse').click();
                }

                this.$emit('onRouteClicked');
            },
            getNotification(type) {
                if(type) {
                    if(this.user && this.user.ID > 0) {
                        if(this.notification_data) {
                            let notif = this.notification_data[type];

                            if(notif !== undefined) {
                                return notif;
                            }
                        }
                    }
                }
            },
            getApplicationModuleByGroupID(id) {
                if(id && this.modules) {
                    return this.modules.filter((item) => {
                        return item.group_id === id;
                    });
                }
            }
        },
        mounted(){
            this.getApplicationModules();
            this.toggleNavigation();

            let vm = this;
            setTimeout(function() { vm.getNotifications(); }, this.notification_delay);
        },
        watch: {
          '$route': {
            handler: function(search) {
              this.$store.dispatch('getCurrentUser').then((resp) => {
                //session active, has user and active token
                console.log('current user', resp);
              }).catch((e) => {
                console.log('no current user', e);
                this.$store.commit('setUser', null);
                this.$store.commit('setToken', null);
                this.$messaging.DisplayError('Session expired', 'A munkamenet lejárt. Jelentkezzen be!');
                this.$router.push({
                  path: '/'
                });
              });
            },
            deep: true,
            immediate: true
          },
            notifications: {
                handler: function(newVal) {
                    this.notification_data = newVal;
                }
            },
            applcationModuleGroups: function(newVal) {
                this.module_groups = newVal;
            },
            applcationModules: function(newVal) {
                this.modules = newVal;
            },
        }
    }
</script>

<style>
    .wrapper {
        width: 100%;
        display: flex;
        align-items: stretch;
        overflow-y: auto;
        overflow-x: hidden;
        height: calc(100vh - 3.75rem - 1px);
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition:all 0.3s;
    }
    .wrapper::-webkit-scrollbar {
        width: 10px;
    }

    .wrapper::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,0.3);
        border-radius: 0px;
    }

    .wrapper::-webkit-scrollbar-thumb {
        border-radius: 6px;
        -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,0.2);
    }
    .wrapper nav{
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition:all 0.3s;
    }

    #sidebar.active {
        margin-left: -250px;
    }
    #sidebar {
        width: 100%;
    }
    .sidebar-header{
        padding-top: 4px;
    }
    a[data-toggle="collapse"] {
        position: relative;
    }

    .dropdown-toggle::after {
        display: block;
        position: absolute;
        top: 51%;
        right: 0px;
        transform: translateY(-50%);
    }
    .menu-btn{
        color: #333;
        background-color: #fff;
        border: none;
        box-shadow: none;
        cursor: pointer;
        position: absolute;
        left: 87%;
        top: 10px;
    }
    .menu-btn:not(:disabled):not(.disabled):active, .menu-btn:hover, .menu-btn:active:focus {
        color:#333;
        background-color: #fff;
        border:none;
        box-shadow: none;
        cursor: pointer;
    }
    .nav-title{
        text-align: center;
    }
    .nav-title a{
        font-weight: 500;
        color: #3d5170;
        font-weight: bold;
        font-size: 12px;
    }
    .nav-title a:hover{
        text-decoration: none;
    }
    .nav-title img{
        height: 32px;
    }
    .nav-title span{
        position: relative;
        top: 3px;
        left: 10px;
        text-transform: uppercase;
    }
    .nav-group-title{
        text-transform: uppercase;
        margin: 0;
        font-size: .625rem;
        letter-spacing: .125rem;
        padding: 1px 1.5625rem;
        font-weight: 500;
        color: #9ea8b9;
        border-bottom: 1px solid #e1e5eb;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .top-menu-item{
        white-space: nowrap;
        min-width: 100%;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
        will-change: background-color,box-shadow,color;
        transition: box-shadow .2s ease,color .2s ease,background-color .2s ease,-webkit-box-shadow .2s ease;
        font-size: .85rem;
        padding: 16px 16px 16px 29px;
        border-left: 4px transparent solid;
    }
    .top-menu-item a{
        white-space: nowrap;
        min-width: 100%;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
        will-change: background-color,box-shadow,color;
        text-decoration: none;
        margin-left: 10px;
        padding-top: 15px;
        padding-bottom: 12px;
    }

    .dropdown-toggle:after {
        display: none;
    }
    .top-menu-item .item-icon-wrapper{
        color: #cacedb;
        float: left;
    }
    .top-menu-item .arrow{
        margin-left: 61%;
        position: relative;
        top: 1px;
        color: #cacedb;
    }
    .top-menu-item span{
        font-weight: 400;
        color: #3d5170;
        transition: box-shadow .2s ease,color .2s ease,background-color .2s ease,-webkit-box-shadow .2s ease;
    }
    .top-menu-item .item-icon-wrapper i{
        transition: box-shadow .2s ease,color .2s ease,background-color .2s ease,-webkit-box-shadow .2s ease;
    }
    .top-menu-item:hover{
        background-color: #fbfbfb;
        cursor: pointer;
        border-left: 4px #007bff solid;
    }
    .top-menu-item:hover > a span, .top-menu-item:hover > a .item-icon-wrapper i{
        color: #007bff !important;
        transition: box-shadow .2s ease,color .2s ease,background-color .2s ease,-webkit-box-shadow .2s ease;
    }
    .top-menu-item .submenu{
        margin-top: 10px;
    }
    .top-menu-item .submenu li{
        padding: .75rem 1.75rem;
        border-top: 1px solid #f0f2f5;
        font-size: .8125rem;
        font-weight: 400;
        padding-left: 23px;
    }
    .top-menu-item .submenu li a{
        color: #3d5170;
        transition: box-shadow .2s ease,color .2s ease,background-color .2s ease,-webkit-box-shadow .2s ease;
    }
    .top-menu-item .submenu li:hover > a{
        color: #007bff;
    }

    .nav-border-top{
        border-top: 1px solid #e1e5eb;
    }

    @media (max-width: 767px) {
        #sidebar {
            margin-left: 100%;
        }
        #sidebar.active {
            margin-left: 0;
        }
        .notif-bell{
            position: absolute;
            top: -61px;
            left: 0px;
        }
        .content-head {

        }
    }

</style>
